const convertFirstColumnToRowHeaders = (table) => {
    try {
        const tbodies = table.querySelectorAll('tbody');
        tbodies.forEach(tbody => {
            const rows = Array.from(tbody.querySelectorAll('tr'));
            rows.forEach(row => {
                const firstCell = row.querySelector('th, td');
                if ((firstCell === null || firstCell === void 0 ? void 0 : firstCell.tagName.toLowerCase()) === 'td') {
                    const th = document.createElement('th');
                    Array.from(firstCell.attributes).forEach(attr => {
                        th.setAttribute(attr.name, attr.value);
                    });
                    th.setAttribute('scope', 'row');
                    th.innerHTML = firstCell.innerHTML;
                    firstCell.replaceWith(th);
                }
            });
        });
    }
    catch (e) {
        // safe fail
        // eslint-disable-next-line no-console
        console.log(`convertFirstColumnToRowHeaders(): ${e}`);
    }
};

export { convertFirstColumnToRowHeaders };
